export const STAYMASKED_TOKEN_COOKIE_NAME = 'sm_token'
export const PAYLAH_UUID_COOKIE_NAME = 'sm_pl_uuid'
export const ENABLE_CREDENTIALS_FOR_REQUEST = false
export const CMS_SPACE_ID = '7ewh4fz86ljr'
export const COLLECTION_END_DATE = new Date('January 23, 2022 23:59:00')
export const PREORDER_START_DATE = new Date('January 10, 2022 10:00:00')
export const PREORDER_END_DATE = new Date('January 22, 2022 23:59:00')
export const PREORDER_PERIOD = '10 Jan to 22 Jan'
export const COLLECTION_PERIOD = '10 Jan to 23 Jan'
export const CHEATSHEET_URL =
  'https://cdn1.stayprepared.sg/wp-content/uploads/sites/12/2021/12/SM6_Cheat_Sheet.pdf'
export const SMS_PROVIDER = 1
